// src/components/dashboard/RecommendationFeed.jsx
import { useNavigate } from 'react-router-dom';
import { C, TYPE_COLORS } from '../../styles/tokens';

const RECOMMENDATIONS = [
  {
    id: '1', title: 'Senior Product Designer', company: 'TechFlow Global',
    loc: 'Remote · USA', pay: '180–240 ONT/mo', match: 96,
    logo: '🎨', type: 'Featured', tags: ['Figma', 'UX', 'Product'],
    posted: '2h ago',
  },
  {
    id: '2', title: 'Web3 Frontend Engineer', company: 'Phantom Wallet',
    loc: 'Remote · Global', pay: '220–300 ONT/mo', match: 91,
    logo: '👻', type: 'Urgent', tags: ['React', 'Solana'],
    posted: '5h ago',
  },
  {
    id: '3', title: 'AI/ML Research Engineer', company: 'DeepMind',
    loc: 'London, UK', pay: '250–350 ONT/mo', match: 88,
    logo: '🧠', type: 'New', tags: ['Python', 'TensorFlow'],
    posted: '1d ago',
  },
];

export default function RecommendationFeed() {
  const navigate = useNavigate();

  return (
    <div className="card" style={{ padding: '22px' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <div>
          <h3 className="syne" style={{ fontSize: '15px', fontWeight: 700 }}>AI Recommendations</h3>
          <p style={{ fontSize: '11px', color: 'rgba(255,255,255,.38)', marginTop: '2px' }}>Matched to your profile</p>
        </div>
        <button
          onClick={() => navigate('/opportunities')}
          style={{ padding: '7px 14px', background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.1)', borderRadius: '8px', color: '#fff', fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}
        >
          Browse All
        </button>
      </div>

      {/* Cards */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {RECOMMENDATIONS.map((job, i) => {
          const typeColor = TYPE_COLORS[job.type] || C.lavender;
          return (
            <div
              key={i}
              style={{ padding: '14px 16px', borderRadius: '12px', background: 'rgba(255,255,255,.025)', border: '1px solid rgba(255,255,255,.06)', cursor: 'pointer', transition: 'all .2s', position: 'relative', overflow: 'hidden' }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = 'rgba(254,52,232,.2)'; e.currentTarget.style.background = 'rgba(254,52,232,.04)'; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(255,255,255,.06)'; e.currentTarget.style.background = 'rgba(255,255,255,.025)'; }}
              onClick={() => navigate(`/opportunities/${job.id}`)}
            >
              {/* Left accent */}
              <div style={{ position: 'absolute', top: 0, left: 0, bottom: 0, width: '3px', background: typeColor }} />

              <div style={{ display: 'flex', gap: '12px', alignItems: 'flex-start', paddingLeft: '8px' }}>
                {/* Logo */}
                <div style={{ width: '42px', height: '42px', borderRadius: '11px', background: 'rgba(255,255,255,.06)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', flexShrink: 0 }}>
                  {job.logo}
                </div>

                {/* Info */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '3px' }}>
                    <div className="syne" style={{ fontSize: '14px', fontWeight: 700, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {job.title}
                    </div>
                    <span className="syne" style={{ fontSize: '14px', fontWeight: 800, color: C.magenta, flexShrink: 0, marginLeft: '8px' }}>
                      {job.match}%
                    </span>
                  </div>
                  <div style={{ fontSize: '11px', color: 'rgba(255,255,255,.4)', marginBottom: '8px' }}>
                    {job.company} · {job.loc}
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
                      {job.tags.slice(0, 2).map(t => (
                        <span key={t} style={{ fontSize: '10px', padding: '2px 7px', borderRadius: '5px', background: 'rgba(255,255,255,.05)', border: '1px solid rgba(255,255,255,.08)', color: 'rgba(255,255,255,.5)' }}>
                          {t}
                        </span>
                      ))}
                      <span style={{ fontSize: '10px', padding: '2px 7px', borderRadius: '5px', background: `${typeColor}15`, border: `1px solid ${typeColor}25`, color: typeColor }}>
                        {job.type}
                      </span>
                    </div>
                    <span style={{ fontSize: '11px', fontWeight: 700, color: C.success, flexShrink: 0 }}>
                      {job.pay}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
